import { env } from "~/env.mjs";
import { siteRoutes } from "~/types/enum";
import { companyDetails } from "./site";

export const BLOB_PARENT_FOLDER = "products";
export const METADATA_KEYWORD = "railway";
export const PLACEHOLDER_IMAGE = `${env.NEXT_PUBLIC_ASSETS_URL}/images/default/placeholder.svg`;

export const projectItems = [
  {
    title: "Fan Art Showcase",
    description: "Explore breathtaking creations from our talented community.",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/fan-art-showcase-Ij3Ij2Ij1Ij0IjZIjYIjX.jpg",
  },
  {
    title: "Mod Spotlight",
    description:
      "Discover game-changing mods crafted by our ingenious modders.",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/mod-spotlight-IjWIjVIjUIjTIjSIjRIjQ.jpg",
  },
  {
    title: "Community Events",
    description:
      "Join fellow chooms in exciting online and offline gatherings.",
    image:
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/community-events-IjPIjOIjNIjMIjLIjKIjJ.jpg",
  },
];

export const featuredItems = [
  {
    title: "Signalling",
    description:
      "Signalling is a system that allows trains to communicate with each other and with the infrastructure.",
    badge: "Signalling",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/home/designer-1.jpg`,
    link: `${siteRoutes.Categories}/signalling`,
  },

  {
    title: "Permanent Way",

    description:
      "Permanent Way is a system that allows trains to communicate with each other and with the infrastructure.",
    badge: "Permanent Way",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/home/designer-3.jpg`,
    link: `${siteRoutes.Categories}/permanent-way`,
  },

  {
    title: "Axle Counters",
    description:
      "Axle Counters is a system that allows trains to communicate with each other and with the infrastructure.",
    badge: "Axle Counters",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/home/designer-7.jpg`,
    link: `${siteRoutes.Categories}/axle-counter`,
  },
];

export const tabData = [
  {
    id: "etcs",
    title: "ETCS",
    images: [
      `/images/storefront/feature/etcs-1.jpg`,

      `/images/storefront/feature/etcs-2.png`,

      `/images/storefront/feature/etcs-3.jpg`,
    ],
    content:
      "ETCS is a system that allows trains to communicate with each other and with the infrastructure. It is a key part of the modern railway system and is used in many countries around the world.",
  },

  {
    id: "gsmr",
    title: "GSMR",
    images: [
      `/images/storefront/feature/gsmr-1.png`,
      `/images/storefront/feature/gsmr-2.png`,
    ],

    content:
      "GSMR is a system that allows trains to communicate with each other and with the infrastructure. It is a key part of the modern railway system and is used in many countries around the world.",
  },

  {
    id: "axlecounter",
    title: "Axle Counter",
    images: [
      `/images/storefront/feature/axlecounter-1.png`,
      `/images/storefront/feature/axlecounter-2.png`,
      `/images/storefront/feature/axlecounter-3.png`,
    ],

    content:
      "The Axle Counter is a device that counts the number of axles on a train. It is a key part of the modern railway system and is used in many countries around the world.",
  },
];

export const featuredProductData = [
  {
    title: "Axle Counters",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-1.jpg`,
  },

  {
    title: "Track Gauges",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-2.png`,
  },

  {
    title: "GRP Troughing",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-3.jpg`,
  },

  {
    title: "Signals",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-4.jpg`,
  },

  {
    title: "Tubular Stretchers",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-5.jpg`,
  },

  {
    title: "Track Trolleys",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-6.jpg`,
  },

  {
    title: "SSI",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-7.jpg`,
  },

  {
    title: "Insulation Tools",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-8.jpg`,
  },

  {
    title: "Cubicles",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-9.jpg`,
  },

  {
    title: "Testing",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-10.jpg`,
  },

  {
    title: "Pandrol Fixings",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-11.jpg`,
  },

  {
    title: "Rubber Crossings",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/feature/product-12.jpg`,
  },
];

export const accordionData = [
  {
    question: "What is the address of your office?",
    answer: companyDetails[0]?.address ?? "",
  },
  {
    question: "What is your opening hours?",
    answer: companyDetails[0]?.openingHours ?? "",
  },
  {
    question: "What is your phone number?",
    answer: companyDetails[0]?.phone ?? "",
  },

  {
    question: "What is your email?",
    answer: companyDetails[0]?.email ?? "",
  },
  {
    question: "What is your VAT number?",
    answer: companyDetails[0]?.vat ?? "",
  },
  {
    question: "What is your WEEE number?",
    answer: companyDetails[0]?.weee ?? "",
  },
];

export const featureSliderData = [
  {
    id: "troughing",
    title: "GRP Troughing",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/troughing/main.jpg`,
        content:
          "Over 50km of Elevated Trackside Cable Management supplied to Iarnrod Eireann installed along the Curragh.",
      },
    ],
  },
  {
    id: "monitoring",
    title: "Monitoring",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/monitoring/main.jpg`,
        content:
          "Programming and Installation of a new Monitoring System for critial assets on Northern Ireland Railways network.",
      },
    ],
  },
  {
    id: "axle-counters",
    title: "Axle Counters",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/axle-counters/main.jpg`,

        content:
          "Design, Supply and Installation of Frauscher Axle Counters on the Waterford to Limerick railway line.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/axle-counters/axle-counter-1.jpg`,
        content: "Indoor Frauscher Equipment installed in SEB room.",
      },
    ],
  },
  {
    id: "impedance",
    title: "Impedance Bonds",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/impedance/main.jpg`,
        content:
          "Undertaking the overhauling of the impedance bond units, testing and commissioning of the repaired units.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/impedance/impedance-1.jpg`,
        content:
          "Overhauling the impedance bond units, testing and commissioning of the repaired units.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/impedance/impedance-2.jpg`,
        content:
          "New design of 83.3Hz bonds were developed by RIVVAL to improve performance and reduce installation time. ",
      },
    ],
  },
  {
    id: "tps",
    title: "IE TPS",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/tps/main.jpg`,
        content:
          "Supply and Installation of IE TPS units for Irish Rails rollout of ETCS in Ireland.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/tps/tps-1.jpg`,
        content:
          "Supply and Installation of IE TPS units for Irish Rails rollout of ETCS in Ireland.",
      },
    ],
  },
];

export const elevatedTroughingInstallationsData = [
  {
    title: "Vic 3",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/vic.jpg`,
  },

  {
    title: "Kildare",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/kildare.jpg`,
  },

  {
    title: "Oslo",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/oslo.jpg`,
  },

  {
    title: "Further Bogen",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/further-bogen.jpg`,
  },

  {
    title: "Esslinger Bergtunnel",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/esslinger-bergtunnel.jpg`,
  },

  {
    title: "Felixstowe",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/felixstowe.jpg`,
  },

  {
    title: "Doncaster",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/doncaster.jpg`,
  },

  {
    title: "Bruckenquerung",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/bruckenquerung.jpg`,
  },

  {
    title: "Esslinger Bergtunnel.",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/esslinger-bergtunnel-2.jpg`,
  },

  {
    title: "Sonderlösung",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/sonderloesung.jpg`,
  },

  {
    title: "Dresden",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/dresden.jpg`,
  },

  {
    title: "Esslinger",
    image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/esslinger.jpg`,
  },
];

export const elevatedTroughingSliderData = [
  {
    id: "vic3",
    title: "Vic 3",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/vic3/main.jpg`,
        content:
          "Phase 3 of the Victoria resignalling will deliver a number of operational benefits. Additional resilience and flexibility will be introduced into the working of this very busy stretch of railway and maintenance requirements will be reduced. The telecoms network will be upgraded as part of the project..",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/vic3/vic3-1.jpg`,
        content:
          "Phase 3 of the Victoria resignalling will deliver a number of operational benefits. Additional resilience and flexibility will be introduced into the working of this very busy stretch of railway and maintenance requirements will be reduced. The telecoms network will be upgraded as part of the project..",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/vic3/vic3-2.jpg`,
        content:
          "Phase 3 of the Victoria resignalling will deliver a number of operational benefits. Additional resilience and flexibility will be introduced into the working of this very busy stretch of railway and maintenance requirements will be reduced. The telecoms network will be upgraded as part of the project..",
      },
    ],
  },
  {
    id: "kildare",
    title: "Kildare",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/kildare/main.jpg`,
        content:
          "Over 50km of Elevated Trackside Cable Management supplied to Iarnrod Eireann installed along the Curragh.",
      },
    ],
  },
  {
    id: "berlin",
    title: "Berlin",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/berlin/main.jpg`,

        content:
          "Elevated Troughing installed in Berlin for the S-Bahn. Which included a range of custom bridge brackets.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/berlin/berlin-1.jpg`,

        content:
          "Elevated Troughing installed in Berlin for the S-Bahn. Which included a range of custom bridge brackets.",
      },
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/berlin/berlin-2.jpg`,

        content:
          "Elevated Troughing installed in Berlin for the S-Bahn. Which included a range of custom bridge brackets.",
      },
    ],
  },
  {
    id: "saarbrucken",
    title: "Saarbrücken",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/saarbrucken/main.jpg`,
        content:
          "3 troughs (2x size 2, 1x size 1) next to each other, installed on 1 pillar.",
      },
    ],
  },
  {
    id: "mahle",
    title: "Mahle",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/mahle/main.jpg`,
        content:
          "Installation of Size 2 troughing in anthracite as charging infrastructure and connector socket.",
      },
    ],
  },
  {
    id: "norway",
    title: "Norway",
    slides: [
      {
        image: `${env.NEXT_PUBLIC_ASSETS_URL}/images/troughing/projects/norway/main.jpg`,
        content: "4.5km of VARIO-TOP size 1 in Norway.",
      },
    ],
  },
];
